<template>
  <v-row>
    <v-col cols="8">
      <v-card style="cursor:pointer" @click="$refs.input_info.click()">
        <v-img v-if="img_serie_md5" height="220" :src="serie_img_src">
          <div class="d-flex justify-end pa-2">
            <v-btn icon color="white" small><v-icon small>mdi-camera</v-icon></v-btn>
          </div>
        </v-img>
        <div v-else class="d-flex flex-column align-center justify-center grey lighten-3" style="height:220px">
          <v-icon x-large color="grey lighten-1">mdi-image-plus-outline</v-icon>
          <span class="text-caption grey--text mt-2">Aggiungi copertina</span>
        </div>
        <input type="file" style="display:none" @change="onFileInfoChange($event)" ref="input_info" />
      </v-card>
    </v-col>
    <v-col cols="4">
      <v-card style="cursor:pointer" @click="$refs.input_brand.click()">
        <v-img v-if="img_serie_brand_md5" height="220" :src="serie_img_brand_src">
          <div class="d-flex justify-end pa-2">
            <v-btn icon color="white" small><v-icon small>mdi-camera</v-icon></v-btn>
          </div>
        </v-img>
        <div v-else class="d-flex flex-column align-center justify-center grey lighten-3" style="height:220px">
          <v-icon x-large color="grey lighten-1">mdi-image-plus-outline</v-icon>
          <span class="text-caption grey--text mt-2">Aggiungi brand</span>
        </div>
        <input type="file" style="display:none" @change="onFileBrandChange($event)" ref="input_brand" />
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-textarea
        rows="5"
        v-model="info_serie"
        outlined
        label="Informazioni Serie"
      />
    </v-col>
  </v-row>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    id_specie: String,
    serie: Object,
  },
  created() {
    this.debounce_info_serie = _.debounce(this.send_info_serie, 2000);
  },
  data() {
    return {
      info_serie: "",
      img_serie_md5: null,
      img_serie_brand_md5: null,
      file_info: null,
      file_brand: null,
      disable_watch: true,
    };
  },
  mounted() {
    this.disable_watch = true;
    this.$store
      .dispatch("fetch_info_serie_by_id", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
      })
      .then((res) => {
        this.info_serie = res.info_serie;
        this.img_serie_md5 = res.img_serie_info_md5;
        this.img_serie_brand_md5 = res.img_serie_brand_md5;
        this.$nextTick(() => {
          this.disable_watch = false;
        });
      });
  },
  watch: {
    info_serie: function () {
      if (this.disable_watch) {
        return;
      }
      this.debounce_info_serie();
    },
  },
  computed: {
    serie_img_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/info_img?md5=" +
        this.img_serie_md5
      );
    },
    serie_img_brand_src() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.id_specie +
        "/serie/" +
        this.serie.id +
        "/brand_img_serie?md5=" +
        this.img_serie_brand_md5
      );
    },
  },
  methods: {
    send_info_serie() {
      this.$store.dispatch("send_serie_info", {
        id_specie: this.id_specie,
        id_serie: this.serie.id,
        info: this.info_serie,
      });
    },
    onFileBrandChange(e) {
      this.file_brand = e.target.files[0];
      this.invia_img_brand();
    },
    onFileInfoChange(e) {
      this.file_info = e.target.files[0];
      this.invia_info_img();
    },
    invia_info_img() {
      let formData = new FormData();
      formData.append("file", this.file_info);
      this.$store
        .dispatch("send_serie_info_img", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
          formData: formData,
        })
        .then((res) => {
          this.img_serie_md5 = res.data.md5;
        })
        .finally(() => {
          this.file_info = null;
        });
    },
    invia_img_brand() {
      let formData = new FormData();
      formData.append("file", this.file_brand);
      this.$store
        .dispatch("send_serie_brand_img", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
          formData: formData,
        })
        .then((res) => {
          this.img_serie_brand_md5 = res.data.md5;
        })
        .finally(() => {
          this.file_brand = null;
        });
    },
  },
};
</script>